import _ from "underscore"
import {cutLongText} from "../../util/StringUtils"
import messageResource from "../../messageResource"
import BaseReportPDFDefinitionBuilder from "../BaseReportPDFDefinitionBuilder";
import BasePDFDefinitionBuilder from "../BasePDFDefinitionBuilder";
import {styles as baseStyles} from "../BaseReportPDFDefinitionBuilder"

export default class PDFDefinitionBuilder extends BaseReportPDFDefinitionBuilder {

    getAdditionalStyles() {
        return styles;
    }

    getAdditionalParameters() {
        return parameters;
    }

    initDocDefinitionObject(withSignatureOnEachPage, headerOnEachPage) {
        BasePDFDefinitionBuilder.prototype.initDocDefinitionObject.call(this, headerOnEachPage);
        var margins = [];
        _.extend(margins, this.dd.pageMargins);

        this.dd.pageMargins = margins;

        var footerMargins = this.p("footerMargins")(this.p("pageMargins"));
        this.dd.footer = function() {
            return function(currentPage, pageCount) {
                return {
                    style: 'rightFooterPageCount',
                    margin: footerMargins,
                    layout: 'noBordersNoPadding',
                    text: messageResource.getMessage('report.chart_pdf.rightFooterLabel', [currentPage, pageCount])
                };
            }
        }();
    }

    makeLegendTotalRow(title, totalSpent) {
        return [
            {text: title, style: 'chartLegendTotal', colSpan: 2},
            {text: ''},
            {text: totalSpent, style: 'chartLegendTotalValue'}
        ];
    }

    makeLegendItemRow(item) {
        var style = (item.originalValue < 0 ) ? ['chartLegendValue', 'negativeValue'] : 'chartLegendValue';
        return [
            {
                canvas:
                    [
                        {
                            type: 'rect',
                            x: 0,
                            y: 0,
                            w: 6,
                            h: 14,
                            color: item.color
                        }
                    ]
            },
            {text: cutLongText(item.name, this.p("itemTextLen")), style: 'chartLegendItem'},
            {text: item.value, style: style}
        ];
    }

    addChartLegend(title, items, total) {
        var tableStyles = this.p("dataTableStyles");
        var tableMargins = {
            top: 2
        };

        var rows = [];
        rows.push(this.makeLegendTotalRow(title, total));

        _.each(items, function(item) {
            rows.push(this.makeLegendItemRow(item));
        }, this);

        var table = {
            style: tableStyles.legendStyle,
            layout: 'headerBorderSeparatedRows',
            marginTop: tableMargins.top,

            table: {
                dontBreakRows: true,
                widths: ['auto', "auto", 'auto'],
                body: rows
            }
        };
        this.appendContentElement(table);
    }

    addChartImage(viewByText, image) {
        var sizes = this.p("chartImageSize");

        this.appendContentElement({
            marginTop: 30,
            marginBottom: 0,
            text: viewByText,
            style: 'viewChartBy',
            headlineLevel: 1
        });

        this.appendContentElement({
                layout: 'noBordersNoPadding',
                headlineLevel: 2,
                marginTop: 5,
                marginBottom: 0,
                table: {
                    width: ['100%'],
                    body: [
                        [
                            {
                                height: sizes.height,
                                width: sizes.width,
                                image: image
                            }
                        ]
                    ]
                }
            }
        );
    }

    createHeaderDataRow(headerData) {
        return {
            firstRow: this.iterateColumns('makeHeader', headerData),
            secondRow: this.iterateColumns('makeSubHeader', headerData)
        };
    }
}

export const parameters = {

    dataTableStyles: {
        tableStyle: 'reportRow',
        legendStyle: 'chartLegend'
    },

    Portrait: {
        columnWidth: {
            levels: 23,
            totals: 10,
            leave: 9,
            balance: 12
        },

        A4: {
            limitOfLinesInTextCell: 62,
            chartImageSize: {
                height: 238,
                width: 515
            }
        },
        Letter: {
            limitOfLinesInTextCell: 56,
            chartImageSize: {
                height: 245,
                width: 530
            }
        }
    },
    Landscape: {
        columnWidth: {
            levels: 15,
            totals: 7,
            leave: 6,
            balance: 9
        },

        A4: {
            limitOfLinesInTextCell: 40,
            chartImageSize: {
                height: 290,
                width: 730
            }
        },
        Letter: {
            limitOfLinesInTextCell: 42,
            chartImageSize: {
                height: 310,
                width: 680
            }
        }
    }
}

export const styles = Object.assign({}, baseStyles, {
    reportSecondGroupingRow: {
        marginLeft: 10,
        alignment: 'left'
    },

    reportTotalTitle: {
        margin: [0, 5, 2, 2]
    },

    reportLevelsTitle: {
        alignment: 'left',
        margin: [6, 15, 2, 2]
    },

    reportTotalTitle: {
        margin: [0, 5, 2, 2]
    },

    reportLeaveTitle: {
        margin: [0, 5, 0, 0]
    },

    reportFirstGroupingRow: {
        bold: true,
        alignment: 'left',
        fillColor: '#f4f4f4',
        marginLeft: 1
    },

    reportSecondGroupingRow: {
        marginLeft: 10,
        bold: true,
        alignment: 'left',
        fillColor: '#f6f6f6'
    },

    chartLegendTotal: {
        alignment: 'left',
        fontSize: 11,
        bold: true
    },

    chartLegendTotalValue: {
        alignment: 'right',
        fontSize: 11,
        bold: true
    },

    chartLegendItem: {
        alignment: 'left',
        fontSize: 10
    },

    chartLegendValue: {
        alignment: 'right',
        fontSize: 10
    }
})


// WEBPACK FOOTER //
// ./web/js/pdf/leavesReport/PDFDefinitionBuilder.js